import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('Modal', {
  CLOSE_OVERLAY: null,
  OPEN_OVERLAY: null
});
